import { actions } from "./action-list";

export function operationTypeFetched(value) {
  return {
    type: actions.FETCH_OPERATION_TYPE,
    value,
  };
}

export function selectedOperationType(value) {
  return {
    type: actions.SELECTED_OPERATION_TYPE,
    value,
  };
}
